import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Message, State } from './state';

const getMessages = (state: State): Message[] => state.messages;

export const selectEventLogState: MemoizedSelector<object, State> = createFeatureSelector<State>('event-log');

export const selectEventLogMessages: MemoizedSelector<object, any> = createSelector(selectEventLogState, getMessages);
